import React, { Component } from "react";
import Information from "../Information";
import ErrorContentLinks from "./sharedErrorContent/ErrorContentLinks";
import { Paths } from "../../../constants/UrlConstants";
import { withRouter } from "react-router-dom";
import Contentify from "../../../content/Contentify";
import Store from "../../../content/Store";
import { Layouts } from "../../../constants/Constants";
import { connect } from "react-redux";
import Button from "../../shared/buttons/Button";

export const mapStateToMovedToAxaHealth = ({ layoutReducer = {} }) => {
  return {
    isHOL: layoutReducer.layout === Layouts.HOL
  };
};

export class MovedToAxaHealth extends Component {
  render() {
    const content = this.props.isHOL ? (
      <Information headerText={this.props.content.heading}>
        {this.props.content.description}
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <ErrorContentLinks />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <Button
              onClick={() =>
                this.props.history.push(Paths.AddAPlanFromNoAccess)
              }
              label={this.props.content.AddANewPlanLinkText}
            />
          </div>
        </div>
      </Information>
    ) : (
      this.props.history.push(Paths.NotFound)
    );
    return content || null;
  }
}

MovedToAxaHealth.content = Store.MovedToAxaHealth;

export default withRouter(
  connect(mapStateToMovedToAxaHealth)(Contentify(MovedToAxaHealth))
);
